import { EventEmitter } from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
//can be used as common service for emr
export class ArtPatientLayoutService {
  primaryServiceRequestId!:any
  isEmrScreen = false;
  isZeroBillingCnfgOn=false;
  constructor(
    public baseService: BaseService,
    public alerts: AlertsService,
    public loaderService?: LoaderService,
    public router?: Router,
    public route?: ActivatedRoute,
    ) { }
  storeMappedPatient(uhid: string, encounterId: string,id:string,patientName:string,prescriptionSent:boolean,stage:string) {
    // Get existing map from sessionStorage
    let mappedPatients = JSON.parse(sessionStorage.getItem("mapped_patients") || "{}");
  
    // Update mapping
   // mappedPatients[uhid] = {encounter_id:encounterId,appointmentId:id};
   mappedPatients[uhid] = {
    ...mappedPatients[uhid],   //  keep existing fields (like status)
    encounter_id: encounterId,
    appointmentId: id,
    patient_name:patientName,
    prescription_sent:prescriptionSent?prescriptionSent:false,
    stage:stage
  };  
    // Save back to sessionStorage
    sessionStorage.setItem("mapped_patients", JSON.stringify(mappedPatients));
  }
  isZeroBillingEnabled(cb: (enabled: boolean) => void) {
    const args = "config_code:billing_841,module_code:billing";
  
    this.baseService
      .get('GET_CONFIG', args, 'facility_config_mapping', 'facility-management')
      .pipe(take(1))
      .subscribe(
        data => {
          let enabled = false;
  
          if (
            data?.errCode === 0 &&
            Array.isArray(data?.resource) &&
            data.resource.length > 0
          ) {
            const config = data.resource[0];
            enabled =
              config.status === 'active' &&
              typeof config.config === 'string' &&
              config.config.includes('Appointment Orders') &&
              config.config.includes('EMR Orders');
          }
  
          this.isZeroBillingCnfgOn = enabled;
          cb(enabled);
        },
        err => {
          this.isZeroBillingCnfgOn = false;
          cb(false);
        }
      );
  }
  
  getIVFData(args: string, isActive?: any, cb?: (data: any) => void) {
    let resourceData = {
      application: "patient-registration",
      resource: "ivf_patient",
      query_id: "GET_PATIENT_BY_IVF_NO",
    };
    this.baseService
      .get(resourceData.query_id, args, resourceData.resource, resourceData.application)
      .subscribe(res => {
        if (res.errCode == 0 && Array.isArray(res.resource) && res.resource.length > 0) {
          if (!isActive) {
            if (cb) cb(null);
            return;
          }
          const IVFData_active = res.resource;
          IVFData_active.forEach(record => {
            record.visitButtonLabel = "Loading...";
            /** PRIMARY PATIENT SETUP */
            if (record?.ivf_primary) {
              const currentData = sessionStorage.getItem('currentData');
              if (currentData) {
                const data = JSON.parse(currentData);
                if (data?.uhId === record.uhId) {
                  if (!sessionStorage.getItem('primaryDetails')) {
                    const ob = {
                      uhId: record.uhId,
                      encounter_id: data['encounter_id'],
                      serviceRequestId: data['serviceRequestId']
                    }
                    sessionStorage.setItem("primaryDetails", JSON.stringify(ob));
                  }
                  if (data?.serviceRequestId) {
                    this.primaryServiceRequestId = data.serviceRequestId;
                  }
                }
              }
            }

            /** GET PRIMARY ENCOUNTER */
            const primaryDetails = JSON.parse(
              sessionStorage.getItem("primaryDetails") || "{}"
            );
            /** STEP 1 CHECK STORED VISIT */
            const visitCheckResource = {

              application: "emr",
              resource: "ivf_mappingDetails",
              query_id: "GET_IVF_MAPPING_DATA",

              args: `uhId:${record.uhId},ivf_no:${record.ivf_no},primary_encounter_id:${primaryDetails.encounter_id}`
            };

            this.baseService.get(
              visitCheckResource.query_id,
              visitCheckResource.args,
              visitCheckResource.resource,
              visitCheckResource.application
            ).subscribe(storedRes => {
              if (storedRes?.errCode == 0 && storedRes?.resource?.length > 0) {
                const visit = storedRes.resource[0];
                const encounterId = visit.encounter_id;

                /** STEP 2  GET VISIT DETAILS */
                this.baseService.get(
                  "GET_PATIENT_DATA_FOR_VISIT_COUNT",
                  '',
                  "appointment",
                  "appointment",
                  `encounter_id:${encounterId}`
                ).subscribe((response: any) => {
                  if (response?.errCode != -1 && response?.resource?.length > 0) {
                    const visitData = response.resource[0];
                    let prescriptionSentStatus = false;
                    if (visitData?.prescription_sent && visitData?.stage !== 'Re Open') {
                      prescriptionSentStatus = true;
                    }
                    record.visitButtonLabel = prescriptionSentStatus
                      ? "Prescription Is Final"
                      : "View Visit";
                    this.storeMappedPatient(
                      visitData.uhId,
                      visitData.encounter_id,
                      visitData.id,
                      visitData.patient_name,
                      prescriptionSentStatus,
                      visitData.stage
                    );
                  }
                  // else {
                  //   record.visitButtonLabel = "View Visit";
                  // }

                }, () => {
                  record.visitButtonLabel = "View Visit";
                });

              } else {
                record.visitButtonLabel = "Generate Visit";
              }

            }, () => {
              record.visitButtonLabel = "Generate Visit";
            });
          });
          if (cb) cb(res.resource);
        } else {
          if (cb) cb(null);
        }
      });
  }
  checkIvfBannerVisibility(url: string): boolean {
    if (!url) {
      return false;
    }

    const tree = this.router.parseUrl(url);
    const segs = tree.root.children['primary']?.segments.map(s => s.path) || [];
    const pathMatches =
      segs.length >= 4 &&
      segs[0] === 'emr' &&
      segs[1] === 'patientlist_format' &&
      segs[2] === 'emr_op_patient' &&
      segs[3] === 'emrDesign';

    const tab0 = (tree.queryParams['tab_0'] || '').toLowerCase();
    const tab1 = tree.queryParams['tab_1'];
    if (tab1) return false;
    const allowedTabs = ['prescription', 
      'travel_history', 
      'birth_history',
      "past_medical_history",
      'past_surgical_history',
      'gynec_history',
      'family_history',
      'social_history',
      'sexual_history',
      'psychosocial_history',
      'marital_history',
      'previous_fertility_history',
      'immunisation_history',
      'previous_investigation_history',
      'oncology_history'
    ];
    let emrVersion=sessionStorage.getItem('emr_version')
    return pathMatches && allowedTabs.includes(tab0)&&emrVersion&&emrVersion=='Version 1';
  }
 
  getDataFromAppointment(uhid: any, ivf_no: any, cb: any) {
    const primaryEncounterIdString = sessionStorage.getItem('primaryDetails');
    let primaryDetails: any = {};
  
    if (primaryEncounterIdString) {
      primaryDetails = JSON.parse(primaryEncounterIdString);
    }
    if (!primaryDetails?.encounter_id) {
      cb(false);
      return;
    }
    this.loaderService.showSpinner();
    /** STEP 1 → GET STORED VISIT DATA */
    const storedArgs =
      `uhId:${uhid},ivf_no:${ivf_no},primary_encounter_id:${primaryDetails.encounter_id}`;
      this.baseService.get(
      "GET_IVF_MAPPING_DATA",
      storedArgs,
      "ivf_mappingDetails",
      "emr",
    ).subscribe((storedRes: any) => {
      if (storedRes?.errCode === 0 && storedRes?.resource?.length > 0 &&storedRes.resource[0].encounter_id) {
        const encounterId = storedRes.resource[0].encounter_id;
        /** STEP 2 → GET VISIT DETAILS USING ENCOUNTER ID */
        this.baseService.get(
          "GET_PATIENT_DATA_FOR_VISIT_COUNT",
          `encounter_id:${encounterId}`,
          "appointment",
          "appointment",
          `encounter_id:${encounterId}`,
        ).subscribe((response: any) => {
  
          this.loaderService.hideSpinner();
  
          if (response.errCode == 0 && response.resource?.length > 0) {
            cb(response.resource[0]);
          } else {
            cb(false);
  
          }
  
        }, () => {
  
          this.loaderService.hideSpinner();
          cb(false);
  
        });
  
      } else {
  
        this.loaderService.hideSpinner();
        cb(false);
  
      }
  
    }, () => {
  
      this.loaderService.hideSpinner();
      cb(false);
  
    });
  
  }
  
  handleVisitData(ivf: any, currentTab0: any) {
    this.getDataFromAppointment(ivf.uhId, ivf.ivf_no, (appointment) => {
      if (!appointment) {
        this.alerts.error("Appointment not found/generated");
        this.loaderService.hideSpinner();
        return;
      }
     setTimeout(()=>{
      if (appointment.encounter_id) {
        let prescriptionSentStatus=false;
        if (appointment?.prescription_sent && appointment?.stage !== 'Re Open') {
         prescriptionSentStatus=true; 
        }
        this.storeMappedPatient(
          appointment.uhId,
          appointment.encounter_id,
          appointment.id,
          appointment.patient_name,
          prescriptionSentStatus,
          appointment.stage ? appointment.stage : ''
        );
        const originalKeyId = appointment?.id;
      const newBanner = {
        selector: 'emr-patient-layout',
        component: 'hidden',
        datasource: {
          application: 'appointment',
          resource: 'appointment',
          query_id: 'get_patient_data_for_appointment',
          args: ``
        },
        jsonName: 'emr_op_patient_banner'
      };
      const urlTree = this.router.createUrlTree([], {
        relativeTo: this.route,
        queryParams: {
          ...this.route.snapshot.queryParams,
          key: originalKeyId,
          banner: JSON.stringify(newBanner),
          returnUrl: this.route.snapshot.queryParams.returnUrl,
          tab_0: "prescription"
        }
      });
      this.loaderService.hideSpinner();
      const finalUrl = this.router.serializeUrl(urlTree);      
      window.location.href = finalUrl;
      }
     },150)
      
    });
  }
  
  
  checkAndStorePrimaryEncounter(bannerJson: any, cb?: () => void) {
    if (!bannerJson?.key) return;
    if (!sessionStorage.getItem("primaryDetails")) {
      const ivfNo = bannerJson.key.ivf_no;
      const uhId = bannerJson.key.uhId;
      const encounterId = bannerJson.key.encounter_id;
      const serviceRequestId = bannerJson.key.serviceRequestId;
      this.baseService.get(
        "GET_PATIENT_BY_IVF_NO",
        `ivf_no:${ivfNo}`,
        "ivf_patient",
        "patient-registration"
      ).subscribe(res => {
        if (res?.resource && Array.isArray(res.resource) && res.resource.length > 0) {
          const primary = res.resource.find(x => x.ivf_primary && x.uhId == uhId);
          if (primary && primary.uhId === uhId) {
            const payload = {
              ivf_no: ivfNo,
              uhId: uhId,
              primary_encounter_id: encounterId,
              encounter_id: encounterId
            };

            this.baseService.action(
              payload,
              "STORE_MAPPING_DETAILS",
              "emr",
              "ivf_mappingDetails"
            ).subscribe(() => {
              sessionStorage.setItem("primaryDetails", encounterId);
              const primaryDetails = {
                uhId: uhId,
                encounter_id: encounterId,
                serviceRequestId: serviceRequestId
              };
              sessionStorage.setItem("primaryDetails", JSON.stringify(primaryDetails));
              if (cb) cb();
            });
          }
        }
      });

    } else {
      if (cb) cb();
    }
  }
  removeArtPatientData()
  {
    sessionStorage.removeItem('mapped_patients');
      sessionStorage.removeItem('primaryDetails');
      //sessionStorage.removeItem('primaryUhid');
      //sessionStorage.removeItem('primaryEncounterId');
      //sessionStorage.removeItem('primaryServiceRequestId');
  }
  /**  Creates a visit first, then delegates to handleVisitData */
  
  createVisit(ivf: any, serviceRequestId: any, currentTab0: any) {
    this.loaderService.showSpinner();
    if (!serviceRequestId) {
      this.alerts.error("no service request id found");
      this.loaderService.hideSpinner();
      return;
    }
    this.isZeroBillingEnabled((enabled) => {

      if (!enabled) {
        this.alerts.error('Zero billing is not enabled. Visit cannot be created.');
        this.loaderService.hideSpinner();
        return;
      }
      const payload = {
        request_source: ivf.uhId,
        serviceRequestId: serviceRequestId,
        emr_type_flow_code: "art_consultation"
      };

      this.baseService
        .action(payload, 'CREATE_MULTIPLE_REVIEW_VISITS', 'order', 'service_request')
        .subscribe(res => {

          if (res.errCode !== 0) {
            this.alerts.error(res.message);
            this.loaderService.hideSpinner();
            return;
          }
          this.alerts.success(res.message);
          this.getLatestVisit(ivf).subscribe((response: any) => {
            if (response?.errCode !== 0 || !Array.isArray(response?.resource) || response.resource.length === 0) {
              this.loaderService.hideSpinner();
              return;
            }
            const visit = response.resource[response.resource.length - 1];
            this.storeVisitMapping(ivf, visit).subscribe((storedData) => {
              if (storedData?.errCode !== 0) {
                this.alerts.error(storedData.message);
                this.loaderService.hideSpinner();
                return;
              }
              this.handleVisitData(ivf, currentTab0);
            }, () => {
              this.loaderService.hideSpinner();   //  missing earlier
            });      
          }, () => {
            this.loaderService.hideSpinner();   //  missing earlier
          });      
        },
        () => {
          this.loaderService.hideSpinner();     //  IMPORTANT
        });
    })
  }
  getLatestVisit(ivf: any) {
    const slotDate = new Date().setHours(0, 0, 0, 0);
    const filter =
      `uhId:${ivf.uhId},slotDate:${slotDate},ivf_no:${ivf.ivf_no},emr_type_flow_code:art_consultation`;
    return this.baseService.get(
      "GET_PATIENT_DATA_FOR_VISIT_COUNT",
      `ivf_no:${ivf.ivf_no}`,
      "appointment",
      "appointment",
      filter
    );
  }
  storeVisitMapping(ivf: any, visit: any) {
    const primaryDetails = JSON.parse(sessionStorage.getItem("primaryDetails") || "{}");
    const payload = {
      uhId: visit.uhId,
      ivf_no: ivf.ivf_no,
      encounter_id: visit.encounter_id,
      primary_encounter_id: primaryDetails?.encounter_id
    };
    return this.baseService.action(payload, "STORE_MAPPING_DETAILS", "emr", "ivf_mappingDetails");
  }
}